import { CurrencyPipe, DecimalPipe, NgClass } from "@angular/common";
import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
} from "@angular/core";

import { QPilotScheduledOrder } from "../types/scheduled-order";
import { DateFormatPipe } from "../pipes/date-format-pipe";
import { QPilotSiteSettings } from "../types/site";
import { BarTagComponent } from "../bar-tag/bar-tag.component";
import { NextimeService } from "../../services/nextime.service";

@Component({
  selector: "lib-scheduled-order-shipping",
  standalone: true,
  imports: [
    NgClass,
    DateFormatPipe,
    DecimalPipe,
    CurrencyPipe,
    BarTagComponent,
    DateFormatPipe,
  ],
  providers: [DecimalPipe, CurrencyPipe, DateFormatPipe],
  templateUrl: "./scheduled-order-shipping.component.html",
  styleUrl: "./scheduled-order-shipping.component.scss",
})
export class ScheduledOrderShippingComponent implements OnChanges {
  @Input() order: QPilotScheduledOrder;
  @Input() useNextime: boolean;
  @Input() isChangeShippingAddressEnabled: boolean = true;
  @Input() siteSettings: QPilotSiteSettings;
  @Output() changeShippingAddress = new EventEmitter();
  @Output() changeDeliveryDate = new EventEmitter();

  processingStatusList = ["processing", "queued"];
  isProcessing: boolean;
  isActive: boolean;
  shippingTotal: string | null | undefined;
  shippingTag: string;
  effectiveUseNextime: boolean;

  constructor(
    private readonly decimalPipe: DecimalPipe,
    private readonly currencyPipe: CurrencyPipe,
    private readonly dateFormatPipe: DateFormatPipe,
    private readonly nextimeService: NextimeService,
  ) { }

  ngOnChanges() {
    this.isProcessing = this.processingStatusList.includes(this.order.status);
    this.isActive = this.order.status == "active";
    const decimalShipping = this.decimalPipe.transform(
      this.order.shippingTotal,
      "1.0-2",
    );
    this.shippingTotal = this.currencyPipe.transform(
      decimalShipping,
      "USD",
      "symbol",
    );

    this.effectiveUseNextime = this.useNextime &&
      this.nextimeService.getShouldDisplayDeliveryDate() &&
      this.nextimeService.getShouldAlignNextOrderDate();

    // Completely ignore delivery date when feature flags are disabled
    const deliveryDate = this.effectiveUseNextime && this.order.estimatedDeliveryDate?.trim()
        ? this.dateFormatPipe.transform(
          this.order.estimatedDeliveryDate,
            "MMM d",
            this.siteSettings.utcOffset,
          )
      : null;

    const shippingRateName = this.order.preferredShippingRateOption || this.order.shippingRateName;
    this.shippingTag = `${shippingRateName ?? ""} ${
      deliveryDate ? "(Delivery " + deliveryDate + ")" : ""
    }`.trim();
  }

  onChangeShippingAddress() {
    this.changeShippingAddress.emit();
  }

  onChangeDeliveryDate() {
    this.changeDeliveryDate.emit();
  }
}
